document.addEventListener("DOMContentLoaded", () => {
  const modal       = document.getElementById("sr-modal");
  const openBtn     = document.getElementById("sr-open");
  const closeBtn    = document.getElementById("sr-close");
  const backdrop    = document.getElementById("sr-backdrop");
  const step1       = document.getElementById("sr-step-1");
  const step2       = document.getElementById("sr-step-2");
  const step3       = document.getElementById("sr-step-3");
  const stepResult  = document.getElementById("sr-step-result");
  const progressBar = document.getElementById("sr-progress-bar");
  const errorMsg    = document.getElementById("sr-error");

  let userHeight = 0;
  let userWeight = 0;
  let userChest  = 0;
  let fitPref    = "regular";

  // ─── Type de produit ──────────────────────────────────────────────────────────
  const productType = (window.sizeGuideData || {}).type || "tee";
  const isPants     = productType === "pants";

  // ─── Ease de base par type de produit (calibrée sur cobayes réels) ────────────
  // tee     : coupe oversize de base → ease regular = 20cm
  // jacket  : coupe regular avec couches dessous → ease regular = 26cm
  // zip     : coupe oversize → ease regular = 36cm
  // pants   : tour de taille → ease regular = 7cm
  const baseEaseByType = { tee: 20, jacket: 26, zip: 36, pants: 7 };
  const baseEase = baseEaseByType[productType] || 14;

  // ─── Estimation corporelle ────────────────────────────────────────────────────
  // Poitrine : OLS calibrée sur données anthropométriques EU (MAE < 1cm)
  function estimateChest(h, w) {
    return Math.round(0.54 * w + 0.05 * h + 48);
  }
  // Tour de taille : calibrée pantalon
  function estimateWaist(h, w) {
    return Math.round(0.56 * w + 0.02 * h + 34);
  }

  // ─── Adaptation UI selon le type ─────────────────────────────────────────────
  function adaptToProductType() {
    if (isPants) {
      const step2Label = document.querySelector("#sr-step-2 .sr-step-label");
      if (step2Label) step2Label.textContent = "Step 2 of 3 — Waist circumference";
      const chestLabel = document.querySelector('label[for="sr-chest"]');
      if (chestLabel) chestLabel.textContent = "Waist — full circumference";
      const chestInput = document.getElementById("sr-chest");
      if (chestInput) chestInput.placeholder = "ex. 80 (optional)";
      const img = document.getElementById("sr-measure-img");
      if (img) img.src = img.src.replace("sr-chest.svg", "sr-waist.svg");
    }
  }

  // ─── Placeholders : valeurs moyennes réalistes ────────────────────────────────
  function setPlaceholders() {
    // Placeholders fixes par type — plus représentatifs qu'une moyenne des plages
    const placeholders = {
      tee:    { h: 175, w: 70 },
      jacket: { h: 175, w: 70 },
      zip:    { h: 175, w: 70 },
      pants:  { h: 175, w: 70 },
    };
    const p = placeholders[productType] || { h: 175, w: 70 };
    document.getElementById("sr-height").placeholder = p.h;
    document.getElementById("sr-weight").placeholder = p.w;
    document.getElementById("sr-chest").placeholder  = isPants ? "ex. 80 (optional)" : "ex. 92 (optional)";
  }

  setPlaceholders();
  adaptToProductType();

  // ─── Open / close ─────────────────────────────────────────────────────────────
  function openModal() {
    modal.classList.add("sr-visible");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("sr-locked");
  }
  function closeModal() {
    modal.classList.remove("sr-visible");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("sr-locked");
  }
  openBtn.addEventListener("click", openModal);
  closeBtn.addEventListener("click", closeModal);
  backdrop.addEventListener("click", closeModal);

  // ─── Navigation ───────────────────────────────────────────────────────────────
  function showStep(stepEl, progress) {
    [step1, step2, step3, stepResult].forEach(s => s.classList.remove("sr-active"));
    stepEl.classList.add("sr-active");
    progressBar.style.width = progress + "%";
  }

  // ─── Step 1 ───────────────────────────────────────────────────────────────────
  document.getElementById("sr-next-1").addEventListener("click", () => {
    const h = parseInt(document.getElementById("sr-height").value);
    const w = parseInt(document.getElementById("sr-weight").value);
    if (!h || !w || h < 140 || h > 220 || w < 35 || w > 160) {
      errorMsg.classList.remove("hidden");
      return;
    }
    errorMsg.classList.add("hidden");
    userHeight = h;
    userWeight = w;
    showStep(step2, 50);
  });

  // ─── Step 2 : chest/waist optionnel ──────────────────────────────────────────
  const next2      = document.getElementById("sr-next-2");
  const chestInput = document.getElementById("sr-chest");
  next2.disabled   = false;

  document.getElementById("sr-back-2").addEventListener("click", () => showStep(step1, 25));
  next2.addEventListener("click", () => {
    const val = parseInt(chestInput.value);
    userChest = (val && val >= 50 && val <= 160) ? val : 0;
    showStep(step3, 75);
  });

  // ─── Step 3 : fit preference ──────────────────────────────────────────────────
  const fitBtns = document.querySelectorAll(".sr-fit-btn");
  fitBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      fitBtns.forEach(b => b.classList.remove("sr-fit-active"));
      btn.classList.add("sr-fit-active");
      fitPref = btn.dataset.fit;
    });
  });

  document.getElementById("sr-back-3").addEventListener("click", () => showStep(step2, 50));

  document.getElementById("sr-result-btn").addEventListener("click", () => {
    const { recommended, scores } = calculateSize();

    document.getElementById("sr-size-badge").textContent = recommended;

    const fitLabel    = fitPref === "fitted" ? "fitted" : fitPref === "oversize" ? "oversized" : "regular";
    const measureUsed = userChest > 0
      ? userChest
      : isPants ? estimateWaist(userHeight, userWeight) : estimateChest(userHeight, userWeight);
    const measureLabel = isPants ? "cm waist" : "cm chest";
    const measureNote  = userChest > 0
      ? `${userChest} ${measureLabel}`
      : `~${measureUsed} ${measureLabel} (estimated)`;

    document.getElementById("sr-fit-context").textContent = `Based on your ${fitLabel} preference`;
    document.getElementById("sr-size-sub").textContent    = `${userHeight} cm · ${userWeight} kg · ${measureNote}`;

    renderGauge(recommended, scores);
    showStep(stepResult, 100);
  });

  // ─── Algorithme ───────────────────────────────────────────────────────────────
  function calculateSize() {
    const data       = window.sizeGuideData || {};
    const sizes      = data.sizes || data;
    const order      = ["XS", "S", "M", "L", "XL", "XXL"];
    const measureKey = isPants ? "waist" : "chest";

    // Mesure corporelle réelle ou estimée
    const corpo = userChest > 0
      ? userChest
      : isPants ? estimateWaist(userHeight, userWeight) : estimateChest(userHeight, userWeight);

    // Aisance par fit — décalage autour de la base calibrée par pièce
    // fitted  : base - 8cm (plus ajusté que la coupe prévue)
    // regular : base      (porter comme prévu)
    // oversize: base + 8cm (encore plus loose)
    const easeMap = {
      fitted:   baseEase - 8,
      regular:  baseEase,
      oversize: baseEase + 8,
    };
    const ease   = easeMap[fitPref] || baseEase;
    const target = corpo + ease;

    // Points signal chest : plus fort pour fitted/oversize
    const measurePts = fitPref === "regular" ? 8 : 12;

    let scores = {};
    order.forEach(s => { scores[s] = 0; });

    // ── Signal A : hauteur — 10 pts ──────────────────────────────────────────────
    let heightMatched = false;
    for (const size of order) {
      const s = sizes[size];
      if (!s) continue;
      if (userHeight >= s.minHeight && userHeight <= s.maxHeight) {
        scores[size] += 10;
        heightMatched = true;
      }
    }
    if (!heightMatched) {
      let bestDiff = Infinity, bestSize = "M";
      for (const size of order) {
        const s = sizes[size];
        if (!s) continue;
        const mid  = (s.minHeight + s.maxHeight) / 2;
        const diff = Math.abs(userHeight - mid);
        if (diff < bestDiff) { bestDiff = diff; bestSize = size; }
      }
      scores[bestSize] += 10;
    }

    // Contrainte dure hauteur
    for (const size of order) {
      const s = sizes[size];
      if (!s) continue;
      if (s.maxHeight && userHeight > s.maxHeight + 2) scores[size] = -999;
    }

    // ── Signal B : poids — 5 pts ─────────────────────────────────────────────────
    for (const size of order) {
      const s = sizes[size];
      if (!s || scores[size] === -999) continue;
      if (userWeight >= s.minWeight && userWeight <= s.maxWeight) scores[size] += 5;
    }
    const weightHit = order.some(sz => sizes[sz] && scores[sz] !== -999 &&
      userWeight >= sizes[sz].minWeight && userWeight <= sizes[sz].maxWeight);
    if (!weightHit) {
      let bestDiff = Infinity, bestSize = "M";
      for (const size of order) {
        const s = sizes[size];
        if (!s || scores[size] === -999) continue;
        const mid  = (s.minWeight + s.maxWeight) / 2;
        const diff = Math.abs(userWeight - mid);
        if (diff < bestDiff) { bestDiff = diff; bestSize = size; }
      }
      scores[bestSize] += 5;
    }

    // ── Signal C : mesure vêtement vs cible ──────────────────────────────────────
    {
      let bestDiff = Infinity, bestSize = null;
      for (const size of order) {
        const s = sizes[size];
        if (!s || scores[size] === -999 || !s[measureKey]) continue;
        const diff = Math.abs(s[measureKey] - target);
        if (diff < bestDiff) { bestDiff = diff; bestSize = size; }
      }
      if (bestSize) {
        scores[bestSize] += measurePts;
        const idx = order.indexOf(bestSize);
        if (idx > 0 && scores[order[idx - 1]] !== -999) scores[order[idx - 1]] += 2;
        if (idx < order.length - 1 && scores[order[idx + 1]] !== -999) scores[order[idx + 1]] += 2;
      }
    }

    // ── Pénalités fit ─────────────────────────────────────────────────────────────
    if (fitPref === "fitted")   ["XL", "XXL"].forEach(sz => { if (scores[sz] > -999) scores[sz] -= 5; });
    if (fitPref === "oversize") ["XS", "S"].forEach(sz   => { if (scores[sz] > -999) scores[sz] -= 5; });

    // ── Taille finale ─────────────────────────────────────────────────────────────
    let recommended = "M", maxScore = -Infinity;
    for (const size of order) {
      if (!sizes[size]) continue;
      if ((scores[size] || 0) > maxScore) {
        maxScore    = scores[size];
        recommended = size;
      }
    }

    return { recommended, scores };
  }

  // ─── Gauge ────────────────────────────────────────────────────────────────────
  function renderGauge(recommended, scores) {
    const data      = window.sizeGuideData || {};
    const sizes     = data.sizes || data;
    const order     = ["XS", "S", "M", "L", "XL", "XXL"];
    const available = order.filter(s => sizes[s] && (scores[s] || 0) > -999);
    const idx       = available.indexOf(recommended);
    if (idx === -1) return;

    const start        = Math.max(0, Math.min(idx - 1, available.length - 3));
    const visible      = available.slice(start, start + 3);
    const posInVisible = visible.indexOf(recommended);
    const prevSize     = visible[posInVisible - 1];
    const nextSize     = visible[posInVisible + 1];
    const recScore     = Math.max(scores[recommended] || 1, 1);
    const prevScore    = prevSize ? Math.max(scores[prevSize] || 0, 0) : 0;
    const nextScore    = nextSize ? Math.max(scores[nextSize] || 0, 0) : 0;

    const slotWidth = 100 / visible.length;
    let pct = (posInVisible + 0.5) * slotWidth;
    if (nextScore > 0) pct += slotWidth * Math.min((nextScore / recScore) * 0.4, 0.4);
    if (prevScore > 0) pct -= slotWidth * Math.min((prevScore / recScore) * 0.4, 0.4);
    pct = Math.max(5, Math.min(95, pct));

    const labelsEl = document.getElementById("sr-gauge-labels");
    labelsEl.innerHTML = "";
    visible.forEach(size => {
      const el       = document.createElement("span");
      el.className   = "sr-gauge-label" + (size === recommended ? " sr-gauge-active" : " sr-gauge-secondary");
      el.textContent = size;
      labelsEl.appendChild(el);
    });

    const hintLeft  = document.querySelector("#sr-gauge-hints span:first-child");
    const hintRight = document.querySelector("#sr-gauge-hints span:last-child");
    hintLeft.classList.toggle("sr-hint-visible", !!prevSize);
    hintRight.classList.toggle("sr-hint-visible", !!nextSize);

    document.getElementById("sr-gauge-cursor").style.left = pct + "%";
    document.getElementById("sr-gauge-cursor-label").style.display = "none";
  }

  // ─── Select size ──────────────────────────────────────────────────────────────
  document.getElementById("sr-select").addEventListener("click", () => {
    const size = document.getElementById("sr-size-badge").textContent;
    document.querySelectorAll(
      '.product__form [data-value], .variant-buttons [data-value], input[type="radio"][value]'
    ).forEach(btn => {
      const val = btn.dataset.value || btn.value || btn.textContent.trim();
      if (val.toUpperCase() === size.toUpperCase()) btn.click();
    });
    closeModal();
  });

  // ─── Restart ──────────────────────────────────────────────────────────────────
  document.getElementById("sr-restart").addEventListener("click", () => {
    ["sr-height", "sr-weight", "sr-chest"].forEach(id => {
      document.getElementById(id).value = "";
    });
    next2.disabled = false;
    fitBtns.forEach(b => b.classList.remove("sr-fit-active"));
    document.querySelector('.sr-fit-btn[data-fit="regular"]').classList.add("sr-fit-active");
    fitPref    = "regular";
    userHeight = userWeight = userChest = 0;
    showStep(step1, 25);
  });
});
